import { Url } from '@wix/da-url';

export function useSubmitUrl(openSubmitForm = false) {
  return Url.studio({ openSubmitForm });
}
